export default __webpack_public_path__ + "static/new8-03-fe27cb9acbb1788877384b5a9ffabf3d.jpg";